import request from '~/request/index.js'

/**
  *新增面试方案
  *POST /business/process
  *接口ID：210260857
  *接口地址：https://app.apifox.com/link/project/5047271/apis/api-210260857
  */
export const addBusinessProcessApi = (data) => request.post(`/api/v1/business/process`, data)

/**
 * 修改面试方案
  *PUT /business/process
  *接口ID：210260858
  *接口地址：https://app.apifox.com/link/project/5047271/apis/api-210260858
 */
export const editBusinessProcessApi = (data) => request.put(`/api/v1/business/process`, data)

/**
 * 查询面试方案列表
 * GET /business/process/list
 * @param {number} pageSize - 每页显示条数
 * @param {number} pageNum - 页码
 * @param {object} filter - 筛选条件
 * @param {string} recruitmentId - 招聘ID
 */
export const getBusinessProcessListApi = (pageSize, pageNum, filter, recruitmentId) => request.get(
  `/api/v1/business/process/list?isAsc=desc${pageSize ? `&pageSize=${pageSize}` : ''
  }${pageNum ? `&pageNum=${pageNum}` : ''
  }${filter?.title ? `&name=${filter?.title}` : ''
  }${filter?.bindingTemplate ? `&profileName=${filter?.bindingTemplate}` : ''
  }${filter?.processStatus !== undefined && filter?.processStatus !== null && filter?.processStatus !== '' ? `&processStatus=${filter?.processStatus}` : ''
  }${recruitmentId ? `&recruitmentId=${recruitmentId}` : ''
  }${filter?.passAfter ? `&passAfter=${filter?.passAfter}` : ''
  }${filter?.passBefore ? `&passBefore=${filter?.passBefore}` : ''
  }${filter?.processStatusList !== undefined && filter?.processStatusList !== null && filter?.processStatusList !== '' ? `&processStatusList=${filter?.processStatusList}` : ''
  }${filter?.offerStatus !== undefined && filter?.offerStatus !== null && filter?.offerStatus !== '' ? `&offerStatus=${filter?.offerStatus}` : ''
  }${filter?.entryStatus !== undefined && filter?.entryStatus !== null && filter?.entryStatus !== '' ? `&entryStatus=${filter?.entryStatus}` : ''
  }${filter?.interviewTimeAfter ? `&interviewTimeAfter=${filter?.interviewTimeAfter}` : ''
  }${filter?.interviewTimeBefore ? `&interviewTimeBefore=${filter?.interviewTimeBefore}` : ''
  }${filter?.actualInterviewTimeAfter ? `&actualInterviewTimeAfter=${filter?.actualInterviewTimeAfter}` : ''
  }${filter?.actualInterviewTimeBefore ? `&actualInterviewTimeBefore=${filter?.actualInterviewTimeBefore}` : ''
  }${filter?.orderByColumn ? `&orderByColumn=${filter?.orderByColumn || 'updateTime'}` : ''
  }${filter?.createBy ? `&createBy=${filter?.createBy}` : ''
  }${filter?.sourceType ? `&sourceType=${filter?.sourceType}` : ''
  }${filter?.selectAssigneeId ? `&selectAssigneeId=${filter?.selectAssigneeId}` : ''
  }${filter?.nodeStatus ? `&nodeStatus=${filter?.nodeStatus}` : ''
  }${filter?.assigneeId ? `&currentAssigneeId=${filter?.assigneeId}` : ''
  }${filter?.pendingSchedule ? `&pendingSchedule=${filter?.pendingSchedule}` : ''
  }`
)

/**
 * 查询当前用户待办的面试方案列表.
 * @param {*} pageSize 
 * @param {*} pageNum 
 * @param {*} filter 
 * @param {*} recruitmentId 
 * @returns 
 */
export const getMyBusinessProcessListApi = (pageSize, pageNum, filter, recruitmentId) => request.get(
  `/api/v1/business/process/todo?isAsc=desc&orderByColumn=updateTime${pageSize ? `&pageSize=${pageSize}` : ''
  }${pageNum ? `&pageNum=${pageNum}` : ''
  }${filter?.title ? `&name=${filter?.title}` : ''
  }${filter?.processStatus !== undefined && filter?.processStatus !== null && filter?.processStatus !== '' ? `&processStatus=${filter?.processStatus}` : ''
  }${filter?.offerStatus !== undefined && filter?.offerStatus !== null && filter?.offerStatus !== '' ? `&offerStatus=${filter?.offerStatus}` : ''
  }${filter?.entryStatus !== undefined && filter?.entryStatus !== null && filter?.entryStatus !== '' ? `&entryStatus=${filter?.entryStatus}` : ''
  }${filter?.bindingTemplate ? `&profileName=${filter?.bindingTemplate}` : ''
  }${recruitmentId ? `&recruitmentId=${recruitmentId}` : ''
  }${filter?.date ? `&date=${filter?.date}` : ''
  }${filter?.interviewTimeAfter ? `&interviewTimeAfter=${filter?.interviewTimeAfter}` : ''
  }${filter?.interviewTimeBefore ? `&interviewTimeBefore=${filter?.interviewTimeBefore}` : ''
  }${filter?.nodeStatus ? `&nodeStatus=${filter?.nodeStatus}` : ''
  }`
)
/**
 * 获取当前用户还没开始的面试
  GET /api/v1/business/process/todo-waiting
  接口ID：381605851
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-381605851
 */
export const getMyBusinessProcessWaitingListApi = (pageSize, pageNum, filter, recruitmentId) => request.get(
  `/api/v1/business/process/todo-waiting?isAsc=desc&orderByColumn=updateTime${pageSize ? `&pageSize=${pageSize}` : ''
  }${pageNum ? `&pageNum=${pageNum}` : ''
  }${filter?.title ? `&name=${filter?.title}` : ''
  }${filter?.processStatus !== undefined && filter?.processStatus !== null && filter?.processStatus !== '' ? `&processStatus=${filter?.processStatus}` : ''
  }${filter?.offerStatus !== undefined && filter?.offerStatus !== null && filter?.offerStatus !== '' ? `&offerStatus=${filter?.offerStatus}` : ''
  }${filter?.entryStatus !== undefined && filter?.entryStatus !== null && filter?.entryStatus !== '' ? `&entryStatus=${filter?.entryStatus}` : ''
  }${filter?.bindingTemplate ? `&profileName=${filter?.bindingTemplate}` : ''
  }${recruitmentId ? `&recruitmentId=${recruitmentId}` : ''
  }${filter?.date ? `&date=${filter?.date}` : ''
  }${filter?.interviewTimeAfter ? `&interviewTimeAfter=${filter?.interviewTimeAfter}` : ''
  }${filter?.interviewTimeBefore ? `&interviewTimeBefore=${filter?.interviewTimeBefore}` : ''
  }`
)

/**
 * 查询当前用户已完成的面试方案列表.
 * @param {*} pageSize 
 * @param {*} pageNum 
 * @param {*} filter 
 * @param {*} recruitmentId 
 * @returns 
 */
export const getDoneBusinessProcessListApi = (pageSize, pageNum, filter, recruitmentId) => request.get(
  `/api/v1/business/process/done?isAsc=desc&orderByColumn=updateTime${pageSize ? `&pageSize=${pageSize}` : ''
  }${pageNum ? `&pageNum=${pageNum}` : ''
  }${filter?.title ? `&name=${filter?.title}` : ''
  }${filter?.bindingTemplate ? `&profileName=${filter?.bindingTemplate}` : ''
  }${recruitmentId ? `&recruitmentId=${recruitmentId}` : ''
  }${filter?.date ? `&date=${filter?.date}` : ''
  }${filter?.interviewTimeAfter ? `&interviewTimeAfter=${filter?.interviewTimeAfter}` : ''
  }${filter?.interviewTimeBefore ? `&interviewTimeBefore=${filter?.interviewTimeBefore}` : ''
  }`
)
/**
 * 获取面试方案详细信息
  *GET /business/process/{id}
  *接口ID：210260856
  *接口地址：https://app.apifox.com/link/project/5047271/apis/api-210260856
 */
export const inquireBusinessProcessMainApi = (id) => request.get(`/api/v1/business/process/${id}`)

/**
 * 删除面试方案
  *DELETE /business/process/{ids}
  *接口ID：210260859
  *接口地址：https://app.apifox.com/link/project/5047271/apis/api-210260859
 */
export const deleteBusinessProcessMainApi = (ids) => request.delete(`/api/v1/business/process/${ids}`)

/**
 * 修改面试方案节点
  *PUT /business/processNode
  *接口ID：210519595
  *接口地址：https://app.apifox.com/link/project/5047271/apis/api-210519595
 */
export const editBusinessProcessNodeApi = (data) => request.put(`/api/v1/business/processNode`, data)

/**
 * 修改面试方案节点状态
  PATCH /api/v1/business/processNode
  接口ID：247600002
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-247600002
 */
export const patchBusinessProcessNodeApi = (data) => request.patch(`/api/v1/business/processNode/status`, data)

/**
 * 获取面试方案节点详细信息
  GET /api/v1/business/processNode/{id}
  接口ID：210576325
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-210576325
 */
export const getBusinessProcessNodeDataApi = (id) => request.get(`/api/v1/business/processNode/${id}`)

/**
 * 获取面试候选人详细信息
  GET /api/v1/business/candidate/{id}
  接口ID：210581262
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-210581262
 */
export const getBusinessProcessCandidateApi = (id) => request.get(`/api/v1/business/candidate/${id}`)

/**
 * 修改面试候选人
  PUT /api/v1/business/candidate
  接口ID：210581264
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-210581264
 */
export const editBusinessProcessCandidateApi = (data) => request.put(`/api/v1/business/candidate`, data)

/**
 * 删除面试方案
  DELETE /api/v1/business/process/{ids}
  接口ID：210576311
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-210576311
 */
export const deleteBusinessProcessApi = (ids) => request.delete(`/api/v1/business/process/${ids}`)

/**
 * 新增流程节点问题
  POST /api/v1/business/node-question
  接口ID：210700021
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-210700021
 */
export const addNodeQuestionApi = (data) => request.post(`/api/v1/business/node-question`, data)

/**
 * 修改流程节点问题
  PUT /api/v1/business/node-question
  接口ID：210700022
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-210700022
 */
export const editNodeQuestionApi = (data) => request.put(`/api/v1/business/node-question`, data)

/**
 * 删除流程节点问题
  DELETE /api/v1/business/node-question/{ids}
  接口ID：210700023
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-210700023
 */
export const delNodeQuestionApi = (ids) => request.delete(`/api/v1/business/node-question/${ids}`)

/**
 * 查询问题生成状态
 *  GET /api/v1/business/node-question/generation-status/{id}
 */
export const getNodeQuestionGenerationStatusApi = (id) => request.get(`/api/v1/business/node-question/generation-status/${id}`)

/**
 * 修改流程能力得分
  PUT /api/v1/business/processAbility
  接口ID：210700306
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-210700306 
 */
export const editAbilityScoreApi = (data) => request.put(`/api/v1/business/processAbility`, data)
/**
 * 删除流程能力
  DELETE /api/v1/business/processAbility/{ids}
  接口ID：211442469
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-211442469
 */
export const delProcessAbilityApi = (ids) => request.delete(`/api/v1/business/processAbility/${ids}`)

/**
 * 新增背调
  POST /api/v1/process/background-check
  接口ID：210708034
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-210708034
 */
export const addBackgroundCheckApi = (data) => request.post(`/api/v1/process/background-check`, data)

/**
 * 修改背调
  PUT /api/v1/process/background-check
  接口ID：210708035
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-210708035
 */
export const editBackgroundCheckApi = (data) => request.put(`/api/v1/process/background-check`, data)

/**
 * 查询背调列表
  GET /api/v1/process/background-check/list
  接口ID：210708032
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-210708032
 */
export const getBackgroundCheckListApi = (candidateId) => request.get(`/api/v1/process/background-check/list?candidateId=${candidateId}`)

/**
 * 删除背调
  DELETE /api/v1/process/background-check/{ids}
  接口ID：210708036
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-210708036
 */
export const deleteBackgroundCheckApi = (ids) => request.delete(`/api/v1/process/background-check/${ids}`)

/**
 * 获取授权码.
  GET /api/v1/business/candidate/code/{id}
  接口ID：211179438
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-211179438
 */
export const getCandidateCodeApi = (id) => request.get(`/api/v1/business/candidate/code/${id}`)

/**
 * 批量新增节点问题.
  POST /api/v1/business/node-question/batch
  接口ID：211929442
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-211929442
 */
export const postNodeQuestionApi = (data) => request.post(`/api/v1/business/node-question/batch`, data)

/**
 * 归档面试候选人进入人才库.
  PUT /api/v1/business/candidate/archive
  接口ID：213746251
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-213746251
 */
export const editArchiveApi = (data) => request.put(`/api/v1/business/candidate/archive`, data)

/**
 * 分析简历
  PUT /api/v1/business/candidate/{candidateId}/analysis
  接口ID：215637198
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-215637198
 */
export const analyzeInterViewApi = (candidateId) => request.put(`/api/v1/business/candidate/${candidateId}/analysis`)

/**
 * 查询简历问题列表
  GET /api/v1/business/resume-question/list
  接口ID：220372456
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-220372456
 */
export const getResumeQuestionApi = (candidateId) => request.get(`/api/v1/business/resume-question/list?candidateId=${candidateId}`)
export const postProcessAbilityApi = (data) => request.post(`/api/v1/business/processAbility`, data)

/**
 * 批量新增流程能力
  POST /api/v1/business/processAbility/batch
  接口ID：249761213
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-249761213
 */
export const postProcessAbilityBatchApi = (data) => request.post(`/api/v1/business/processAbility/batch`, data)

/**
 * 批量修改流程能力
  PUT /api/v1/business/processAbility/batch
  接口ID：284625200
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-284625200
 */
export const putProcessAbilityBatchApi = (data) => request.put(`/api/v1/business/processAbility/batch`, data)

/**
 * 新增补充评价
  POST /api/v1/process/add-evaluation
  接口ID：227429294
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-227429294
 */
export const addEvaluationApi = (data) => request.post(`/api/v1/process/add-evaluation`, data)

/**
 * 查询补充评价列表
  GET /api/v1/process/add-evaluation/list
  接口ID：227429292
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-227429292
 */
export const getEvaluationListApi = (nodeId) => request.get(`/api/v1/process/add-evaluation/list?isAsc=desc&orderByColumn=createTime&nodeId=${nodeId}`)


/**
 * AI生成问题
 *   POST /api/v1/business/unstructured-examine-question
 *   接口ID：235616334
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-235616334
 */
export const generateQuestionApi = (data) => request.post(`/api/v1/business/unstructured-examine-question`, data)


/**
 * 查询指定节点的非结构化考察问题列表
 *   GET /api/v1/business/unstructured-examine-question/list-by-node
 *   接口ID：236264707
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-236264707
 */
export const getUnstructuredQuestionsApi = ({ nodeId, starAbilityId, parentQuestionId, feedback, fiveWAbilityId }) => request.get('/api/v1/business/unstructured-examine-question/list-by-node', {
  params: {
    nodeId,
    starAbilityId,
    parentQuestionId,
    feedback,
    fiveWAbilityId
  }
})

/**
 * AI生成问题
 *   POST /api/v1/business/unstructured-examine-question
 *   接口ID：235616334
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-235616334
 */
export const generateUnstructuredQuestionApi = (data) => request.post(`/api/v1/business/unstructured-examine-question`, data)

/**
 * 生成指定节点指定问题的非结构化考察问题列表
  GET /api/v1/business/unstructured-examine-question/list-by-question
  接口ID：280597646
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-280597646
 */
export const generateUnstructuredQuestionByQuestionApi = (data) => request.post(`/api/v1/business/unstructured-examine-question/list-by-question`, data)


/**
 * AI生成新增非结构化面试总结
 *   POST /api/v1/business/unstructured-examine-summary/ai
 *   接口ID：237560382
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-237560382
 */
export const generateSummaryApi = (data) => request.post(`/api/v1/business/unstructured-examine-summary/ai`, data)

/**
 * 查询指定节点下的非结构化面试总结列表
 *   GET /api/v1/business/unstructured-examine-summary/list-by-node
 *   接口ID：237571161
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-237571161
 */
export const getSummaryListApi = (nodeId) => request.get(`/api/v1/business/unstructured-examine-summary/list-by-node?nodeId=${nodeId}`)

/**
 * 修改非结构化面试总结
 *   PUT /api/v1/business/unstructured-examine-summary
 *   接口ID：237956084
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-237956084
 */
export const editSummaryApi = (data) => request.put(`/api/v1/business/unstructured-examine-summary`, data)

/**
 * 查询指定类型的非结构化考察问题列表
 *   GET /api/v1/business/unstructured-examine-question/list-by-type
 *   接口ID：239749452
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-239749452
 */
export const getUnstructuredQuestionsByTypeApi = ({
  nodeId,
  questionType,
  starAbilityId,
  fiveWAbilityId,
  parentQuestionId,
  feedback
}) => {
  if (questionType === undefined) {
    throw new Error('questionType is required')
  }
  return request.get(
    `/api/v1/business/unstructured-examine-question/list-by-type`,
    {
      params: {
        nodeId,
        questionType,
        starAbilityId,
        fiveWAbilityId,
        parentQuestionId,
        feedback
      }
    }
  )
}

/**
 * 查询指定节点指定问题的非结构化考察问题列表
  GET /api/v1/business/unstructured-examine-question/list-by-question
  接口ID：280597646
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-280597646
 */
export const getUnstructuredQuestionsByQuestionApi = ({
  nodeId,
  questionType,
  parentQuestionId,
  starAbilityId,
  fiveWAbilityId,
  feedback
}) => request.get(`/api/v1/business/unstructured-examine-question/list-by-question`, {
  params: {
    nodeId,
    questionType,
    parentQuestionId,
    starAbilityId,
    fiveWAbilityId,
    feedback
  }
})
/**
 * 查询非结构化考察问题列表
  GET /api/v1/business/unstructured-examine-question/list
  接口ID：282834601
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-282834601
 */
export const getUnstructuredQuestionsExamineQuestionApi = (parentQuestionId) => request.get(`/api/v1/business/unstructured-examine-question/list?parentQuestionId=${parentQuestionId}`)

/**
 * 非结构化面试-AI为能力项打分
 *   POST /api/v1/business/processAbility/ai-unstructured-score
 *   接口ID：241072505
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-241072505
 */
export const aiUnstructuredScoreApi = (data) => request.post(`/api/v1/business/processAbility/ai-unstructured-score`, data)
/**
 *  更新面试原始对话.
 *  POST /api/v1/business/processNode/{nodeId}/raw-chat
 *  接口ID：240703345
 *  接口地址：https://app.apifox.com/link/project/5047271/apis/api-240703345
 */
export const updateRawChatApi = (nodeId, data) => request.post(`/api/v1/business/processNode/${nodeId}/raw-chat`, data)


/**
 * 结构化面试-AI为能力项打分
 *   POST /api/v1/business/processAbility/ai-structured-score
 *   接口ID：238870996
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-238870996
 */
export const aiStructuredScoreApi = (data) => request.post(`/api/v1/business/processAbility/ai-structured-score`, data)

/**
 * 获取任务完成状态及结果
  GET /api/v1/business/ting-wu/tasks/{taskId}
  接口ID：247641963
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-247641963
 */
export const getfflineTaskApi = (taskId) => request.get(`/api/v1/business/ting-wu/tasks/${taskId}`)

/**
 * 面试官记录笔记
  PATCH /api/v1/business/processNode/record-note
  接口ID：248290934
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-248290934
 */
export const patchRecordNoteApi = (data) => request.patch(`/api/v1/business/processNode/record-note`, data)

/**
 * 变更节点类型.
  PATCH /api/v1/business/processNode/category
  接口ID：249138062
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-249138062
 */
export const changeNodeCategoryApi = (nodeId, data) => request.patch(`/api/v1/business/processNode/${nodeId}/category`, data)

/**
 * 获取STS临时访问凭证
  GET /resource/oss/sts-credential
  接口ID：249603248
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-249603248
 */
export const getStsCredentialApi = () => request.get(`/resource/oss/sts-credential`)

/**
 * 创建面试离线任务
  POST /api/v1/business/ting-wu/interview/offline-task
  接口ID：247609352
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-247609352
 */
export const uploadAliOfflineApi = (data) => request.post(`/api/v1/business/ting-wu/interview/offline-task`, data)
/**
 * 提交面试语音-v2
  POST /api/v1/business/processNode/interview/audio-submit
  接口ID：380431954
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-380431954
 */
export const uploadAudioSubmitApi = (data) => request.post(`/api/v1/business/processNode/interview/audio-submit`, data)

/**
 * 批量修改流程能力分数
  PATCH /api/v1/business/processAbility/score
  接口ID：249761212
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-249761212
 */
export const patchScoreApi = (data) => request.patch(`/api/v1/business/processAbility/score`, data)

/**
 * 获取面试报告详细信息
  GET /api/v1/business/interview-report/{id}
  接口ID：261723290
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-261723290
 */
export const getInterviewReportApi = (id) => request.get(`/api/v1/business/interview-report/${id}`)

/**
 * 新增面试备注
  POST /api/v1/process/interview-remark
  接口ID：281524598
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-281524598
 */
export const addCandidateRemarkApi = (data) => request.post(`/api/v1/process/interview-remark`, data)
/**
 * 查询面试备注列表
  GET /api/v1/process/interview-remark/list
  接口ID：281524596
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-281524596
 */
export const getCandidateRemarkListApi = ({
  processId,
  pageSize,
  pageNum,

}) => {
  const params = {
    isAsc: 'desc',
    orderByColumn: 'updateTime',
    archived: 1,
    pageSize,
    pageNum,
    processId,
  }
  return request.get('/api/v1/process/interview-remark/list', { params })
}
/**
 * 修改面试备注
  PUT /api/v1/process/interview-remark
  接口ID：281524599
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-281524599
 */
export const editCandidateRemarkApi = (data) => request.put(`/api/v1/process/interview-remark`, data)

/**
 * 删除面试备注
  DELETE /api/v1/process/interview-remark/{ids}
  接口ID：281524600
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-281524600
 */
export const delCandidateRemarkApi = (ids) => request.delete(`/api/v1/process/interview-remark/${ids}`)

/**
 * 生成追问建议
  POST /api/v1/business/ting-wu/interview/suggest-question
  接口ID：287308425
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-287308425
 */
export const suggestQuestionApi = (data) => request.post(`/api/v1/business/ting-wu/interview/suggest-question`, data)

/**
 * 查询对话总结以及追问列表
  GET /process/chat-summary/list
  接口ID：288292017
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-288292017
 */
export const getChatSummaryListApi = ({
  nodeId,
  orderByColumn = 'createTime',
  isAsc = 'desc'
}) => request.get(`/process/chat-summary/list`, {
  params: {
    nodeId,
    orderByColumn,
    isAsc
  }
})

/**
  * 根据节点ID查询报告
  GET /process/nodeReport/node/{nodeId}
  接口ID：291302102
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-291302102
  */
export const getNodeReportApi = (nodeId) => request.get(`/process/nodeReport/node/${nodeId}`)

/**
 * 修改面试节点报告
  PUT /process/nodeReport
  接口ID：291302100
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-291302100
  */
export const putNodeReportApi = (data) => request.put(`/process/nodeReport`, data)
/**
 * 新增面试节点报告
POST /process/nodeReport
接口ID：291302099
接口地址：https://app.apifox.com/link/project/5047271/apis/api-291302099
 */
export const postNodeReportApi = (data) => request.post(`/process/nodeReport`, data)




/**
 * 更新入职状态
  PUT /api/v1/business/process/entry-status
  接口ID：295764823
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-295764823
 */
export const putEntryStatusApi = (data) => request.put(`/api/v1/business/process/entry-status`, data)

/**
 * 更新offer状态
  PUT /api/v1/business/process/offer-status
  接口ID：295764824
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-295764824
 */
export const putOfferStatusApi = (data) => request.put(`/api/v1/business/process/offer-status`, data)

/**
 * 
 * 更新面试状态
  PUT /api/v1/business/process/process-status
  接口ID：296233609
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-296233609
 */
export const putProcessStatusApi = (data) => request.put(`/api/v1/business/process/process-status`, data)

/**
 * 重新生成纪要
  POST /process/nodeReport/summary-generate/{nodeId}
  接口ID：344650706
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-344650706
 */
export const postProcessSummaryGenerateApi = (nodeId) => request.post(`/process/nodeReport/summary-generate/${nodeId}`)
/**
 * 获取最新的面试总结
  GET /api/v1/process/interview-summary/latest
  接口ID：365854565
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-365854565
 */
export const getProcessSummaryGenerateLatestApi = (processId) => request.get(`/api/v1/process/interview-summary/generation-status/${processId}`)


/**
 * 生成追问建议
  POST /api/v1/business/processNode/{nodeId}/question-suggestion
  接口ID：364634312
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-364634312
 */
export const postQuestionSuggestionApi = (nodeId, audioUrl) => request.post(`/api/v1/business/processNode/${nodeId}/question-suggestion`, { audioUrl })
/**
 * 生成追问和考察点建议
  POST /api/v1/business/processNode/{nodeId}/follow-up
  接口ID：388691778
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-388691778
 */
export const postFollowUpSuggestionApi = (nodeId, audioUrl) => request.post(`/api/v1/business/processNode/${nodeId}/follow-up`, { audioUrl })

/**
 * 30s面试过程中生成追问情况
  POST /api/v1/business/processNode/{nodeId}/follow-up-situation
  接口ID：401146765
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-401146765
 */
export const postFollowUpSituationApi = (nodeId, data) => request.post(`/api/v1/business/processNode/${nodeId}/follow-up-situation`, data)
/**
 * 60s生成考察维度的完成情况
  POST /api/v1/business/processNode/{nodeId}/assessment-sub-point-completion
  接口ID：400930992
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-400930992
 */
export const postAssessmentSubPointCompletionApi = (nodeId, data) => request.post(`/api/v1/business/processNode/${nodeId}/assessment-sub-point-completion`, data)



/**
 * 生成对话摘要
  POST /api/v1/business/processNode/{nodeId}/chat-summary
  接口ID：365758302
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-365758302
 */
export const postChatSummaryApi = (nodeId, audioUrl) => request.post(`/api/v1/business/processNode/${nodeId}/chat-summary`, { audioUrl })

/**
 * 取消正在进行的面试
  PUT /api/v1/business/processNode/{nodeId}/cancel
  接口ID：365793162
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-365793162
 */
export const putCancelInterviewApi = (nodeId) => request.put(`/api/v1/business/processNode/${nodeId}/cancel`)
/**
 * 生成面试总结
  POST /api/v1/process/interview-summary/generate
  接口ID：366121851
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-366121851
 */
export const postCancelInterviewApi = (data) => request.post(`/api/v1/process/interview-summary/generate`, data)

/**
 * 修改面试流程节点评价
  PUT /api/v1/business/processNode/conclude
  接口ID：366208422
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-366208422
 */
export const putProcessNodeConcludeApi = (data) => request.put(`/api/v1/business/processNode/conclude`, data)
/**
 * 生成面试开场提问
  POST /api/v1/business/processNode/{nodeId}/opening-question
  接口ID：385527463
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-385527463
 */
export const postProcessNodeOpeningQuestionApi = (nodeId) => request.post(`/api/v1/business/processNode/${nodeId}/opening-question`)
/**
 * 生成考察子项
  POST /api/v1/process/assessment-process-sub-point/generate
  接口ID：402155362
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-402155362
 */
export const postAssessmentProcessSubPointGenerateApi = (data) => request.post(`/api/v1/process/assessment-process-sub-point/generate`, data)
/**
 * 查询节点生成考察子项的状态
  GET /api/v1/process/assessment-process-sub-point/generating-status/{nodeId}
  接口ID：402155363
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-402155363
 */
export const getAssessmentProcessSubPointGeneratingStatusApi = (nodeId) => request.get(`/api/v1/process/assessment-process-sub-point/generating-status/${nodeId}`)
/**
 * 获取流程候选人排名情况
  GET /api/v1/business/process/{processId}/candidate-rank
  接口ID：396658928
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-396658928
 */
export const getProcessCandidateRankApi = (processId, type = 0) => request.get(`/api/v1/business/process/${processId}/candidate-rank?showDetail=true&type=${type}`)
/**
 * 通过流程ID查询猜你想问
  GET /api/v1/business/process-suggest-question/process/{processId}
  接口ID：397372617
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-397372617
 */
export const getProcessSuggestQuestionApi = (processId) => request.get(`/api/v1/business/process-suggest-question/process/${processId}`)
/**
 * 发送对话消息（旧接口，已废弃）
  POST /api/v1/business/process-chat-message/send
  接口ID：397371896
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-397371896
 */
export const postProcessChatMessageSendApi = (data) => request.post(`/api/v1/business/process-chat-message/send-stream
    ?processId=${data.processId}&userQuestion=${data.userQuestion}`)

/**
 * 流式发送对话消息（SSE推送）
  POST /api/v1/business/process-chat-message/send-stream
  接口ID：398422859
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-398422859
 * @param {Object} data - 请求参数
 * @param {number} data.processId - 流程ID
 * @param {string} data.userQuestion - 用户问题
 * @param {Function} onMessage - 接收消息的回调函数 (chunk) => void
 * @param {Function} onStart - 开始生成的回调函数 () => void
 * @param {Function} onEnd - 结束生成的回调函数 () => void
 * @param {Function} onError - 错误处理回调函数 (error) => void
 * @returns {Object} 包含 close 方法的对象，用于关闭连接
 */
export const postProcessChatMessageSendStreamApi = (data, { onMessage, onStart, onEnd, onError }) => {
  const baseURL = import.meta.env.VITE_BASE_URL.replace(/\/$/, '');
  const token = localStorage.getItem('token');
  const clientId = import.meta.env.VITE_APP_CLIENT_ID;

  // 构建完整的 SSE URL
  const url = `${baseURL}/api/v1/business/process-chat-message/send-stream?processId=${data.processId}&userQuestion=${encodeURIComponent(data.userQuestion)}`;

  // 使用 fetch 实现 SSE，因为需要自定义 headers
  const controller = new AbortController();
  let currentEvent = null;
  let currentData = '';

  fetch(url, {
    method: 'POST',
    headers: {
      'Authorization': token || '',
      'clientid': clientId || '',
      'Accept': 'text/event-stream',
    },
    signal: controller.signal,
  })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = '';

      const processLine = (line) => {
        if (line.trim() === '') {
          // 空行表示一个完整的事件结束
          if (currentEvent && currentData !== null) {
            const dataToSend = currentData.trim();
            if (dataToSend) {
              try {
                // 尝试解析 JSON
                const parsed = JSON.parse(dataToSend);
                if (currentEvent === 'start' && onStart) {
                  onStart(parsed);
                } else if (currentEvent === 'message' && onMessage) {
                  onMessage(parsed);
                } else if (currentEvent === 'end' && onEnd) {
                  onEnd(parsed);
                } else if (currentEvent === 'error' && onError) {
                  onError(parsed);
                }
              } catch (e) {
                // 如果不是 JSON，直接传递字符串
                if (currentEvent === 'start' && onStart) {
                  onStart(dataToSend);
                } else if (currentEvent === 'message' && onMessage) {
                  onMessage(dataToSend);
                } else if (currentEvent === 'end' && onEnd) {
                  onEnd(dataToSend);
                } else if (currentEvent === 'error' && onError) {
                  onError(dataToSend);
                }
              }
            } else if (currentEvent === 'start' && onStart) {
              // 即使没有数据，也触发 start 事件
              onStart();
            } else if (currentEvent === 'end' && onEnd) {
              // 即使没有数据，也触发 end 事件
              onEnd();
            }
          }
          currentEvent = null;
          currentData = '';
          return;
        }

        if (line.startsWith('event:')) {
          currentEvent = line.substring(6).trim();
        } else if (line.startsWith('data:')) {
          const data = line.substring(5); // 保留原始数据，包括可能的换行
          if (currentData === '') {
            currentData = data;
          } else {
            currentData += '\n' + data;
          }
        }
      };

      const readStream = () => {
        reader.read().then(({ done, value }) => {
          if (done) {
            // 处理剩余的 buffer
            if (buffer) {
              buffer.split('\n').forEach(processLine);
            }
            if (onEnd) onEnd();
            return;
          }

          buffer += decoder.decode(value, { stream: true });
          const lines = buffer.split('\n');
          buffer = lines.pop() || ''; // 保留最后一个不完整的行

          lines.forEach(processLine);

          readStream();
        }).catch(error => {
          if (error.name !== 'AbortError' && onError) {
            onError(error);
          }
        });
      };

      readStream();
    })
    .catch(error => {
      if (onError) onError(error);
    });

  // 返回一个可以关闭连接的对象
  return {
    close: () => controller.abort(),
    abort: () => controller.abort(),
  };
}
/**
 * 流式发送对话消息（使用前端传递的候选人信息，SSE推送）
 * POST /api/v1/business/process-chat-message/send-stream-with-candidate
 * @param {Object} data - 请求参数
 * @param {number} data.processId - 流程ID
 * @param {string} data.userQuestion - 用户问题
 * @param {string} data.candidateResume - 候选人简历（字符串）
 * @param {string} data.interviewDetailsJson - 面试详情（序列化后的JSON字符串）
 * @param {Function} onMessage - 接收消息的回调函数 (chunk) => void
 * @param {Function} onStart - 开始生成的回调函数 () => void
 * @param {Function} onEnd - 结束生成的回调函数 () => void
 * @param {Function} onError - 错误处理回调函数 (error) => void
 * @returns {Object} 包含 close 方法的对象，用于关闭连接
 */
export const postProcessChatMessageSendStreamWithCandidateApi = (data, { onMessage, onStart, onEnd, onError }) => {
  const baseURL = import.meta.env.VITE_BASE_URL.replace(/\/$/, '');
  const token = localStorage.getItem('token');
  const clientId = import.meta.env.VITE_APP_CLIENT_ID;

  // 构建请求体
  const requestBody = {
    processId: data.processId,
    userQuestion: data.userQuestion,
  };

  if (data.candidateResume) {
    requestBody.candidateResume = data.candidateResume;
  }

  if (data.interviewDetailsJson) {
    requestBody.interviewDetailsJson = data.interviewDetailsJson;
  }

  // 构建完整的 SSE URL
  const url = `${baseURL}/api/v1/business/process-chat-message/send-stream-with-candidate`;

  // 使用 fetch 实现 SSE，因为需要自定义 headers
  const controller = new AbortController();
  let currentEvent = null;
  let currentData = '';

  fetch(url, {
    method: 'POST',
    headers: {
      'Authorization': token || '',
      'clientid': clientId || '',
      'Content-Type': 'application/json',
      'Accept': 'text/event-stream',
    },
    body: JSON.stringify(requestBody),
    signal: controller.signal,
  })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = '';

      const processLine = (line) => {
        if (line.trim() === '') {
          // 空行表示一个完整的事件结束
          if (currentEvent && currentData !== null) {
            const dataToSend = currentData.trim();
            if (dataToSend) {
              try {
                // 尝试解析 JSON
                const parsed = JSON.parse(dataToSend);
                if (currentEvent === 'start' && onStart) {
                  onStart(parsed);
                } else if (currentEvent === 'message' && onMessage) {
                  onMessage(parsed);
                } else if (currentEvent === 'end' && onEnd) {
                  onEnd(parsed);
                } else if (currentEvent === 'error' && onError) {
                  onError(parsed);
                }
              } catch (e) {
                // 如果不是 JSON，直接传递字符串
                if (currentEvent === 'start' && onStart) {
                  onStart(dataToSend);
                } else if (currentEvent === 'message' && onMessage) {
                  onMessage(dataToSend);
                } else if (currentEvent === 'end' && onEnd) {
                  onEnd(dataToSend);
                } else if (currentEvent === 'error' && onError) {
                  onError(dataToSend);
                }
              }
            } else if (currentEvent === 'start' && onStart) {
              // 即使没有数据，也触发 start 事件
              onStart();
            } else if (currentEvent === 'end' && onEnd) {
              // 即使没有数据，也触发 end 事件
              onEnd();
            }
          }
          currentEvent = null;
          currentData = '';
          return;
        }

        if (line.startsWith('event:')) {
          currentEvent = line.substring(6).trim();
        } else if (line.startsWith('data:')) {
          const data = line.substring(5); // 保留原始数据，包括可能的换行
          if (currentData === '') {
            currentData = data;
          } else {
            currentData += '\n' + data;
          }
        }
      };

      const readStream = () => {
        reader.read().then(({ done, value }) => {
          if (done) {
            // 处理剩余的 buffer
            if (buffer) {
              buffer.split('\n').forEach(processLine);
            }
            if (onEnd) onEnd();
            return;
          }

          buffer += decoder.decode(value, { stream: true });
          const lines = buffer.split('\n');
          buffer = lines.pop() || ''; // 保留最后一个不完整的行

          lines.forEach(processLine);

          readStream();
        }).catch(error => {
          if (error.name !== 'AbortError' && onError) {
            onError(error);
          }
        });
      };

      readStream();
    })
    .catch(error => {
      if (onError) onError(error);
    });

  // 返回一个可以关闭连接的对象
  return {
    close: () => controller.abort(),
    abort: () => controller.abort(),
  };
}

/**
 * 获取用户的对话历史
  GET /api/v1/business/process-chat-message/history/{processId}
  接口ID：397371897
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-397371897
 */
export const getProcessChatMessageHistoryApi = (processId) => request.get(`/api/v1/business/process-chat-message/history/${processId}`)
/**
 * 催办面试官提交面试结果
  POST /api/v1/business/process/remind
  接口ID：400945569
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-400945569
 */
export const postProcessRemindApi = (data) => request.post(`/api/v1/business/process/remind`, data)
/**
 * 根据节点ID查询最新一条提问分析
  GET /api/v1/process/node-question-analysis/node/{nodeId}
  接口ID：409095892
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-409095892
 */
export const getNodeQuestionAnalysisApi = (nodeId) => request.get(`/api/v1/process/node-question-analysis/node/${nodeId}`)

/**
 * 根据节点ID查询所有AI生成状态（用于前端轮询）
  GET /api/v1/process/node-question-analysis/node/{nodeId}/ai-status
  接口ID：409095893
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-409095893
 */
export const getNodeQuestionAnalysisAiStatusApi = (nodeId) => request.get(`/api/v1/process/node-question-analysis/node/${nodeId}/ai-status`)

/**
 * 重试AI问题分析
  POST /api/v1/process/node-question-analysis/retry/question-analysis/{nodeId}
  接口ID：409169203
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-409169203
 */
export const retryQuestionAnalysisApi = (nodeId) => request.post(`/api/v1/process/node-question-analysis/retry/question-analysis/${nodeId}`)

/**
 * 重试AI指标分析
  POST /api/v1/process/node-question-analysis/retry/metrics-analysis/{nodeId}
  接口ID：409169204
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-409169204
 */
export const retryMetricsAnalysisApi = (nodeId) => request.post(`/api/v1/process/node-question-analysis/retry/metrics-analysis/${nodeId}`)

/**
 * 重试AI面试官点评
  POST /api/v1/process/node-question-analysis/retry/interviewer-comment/{nodeId}
  接口ID：409169205
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-409169205
 */
export const retryInterviewerCommentApi = (nodeId) => request.post(`/api/v1/process/node-question-analysis/retry/interviewer-comment/${nodeId}`)

/**
 * 重试AI提问建议
  POST /api/v1/process/node-question-analysis/retry/question-suggestion/{nodeId}
  接口ID：409169206
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-409169206
 */
export const retryQuestionSuggestionApi = (nodeId) => request.post(`/api/v1/process/node-question-analysis/retry/question-suggestion/${nodeId}`)

/**
 * 重新分析面试提问
  POST /api/v1/process/node-question-analysis/reanalyze/{nodeId}
  接口ID：409895794
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-409895794
 */
export const reanalyzeNodeQuestionAnalysisApi = (nodeId) => request.post(`/api/v1/process/node-question-analysis/reanalyze/${nodeId}`)

/**
 * 获取节点的对话历史
  GET /api/v1/business/node-chat-message/history/{nodeId}
 * @param {number} nodeId - 节点ID
 * @return 对话历史列表
 */
export const getNodeChatMessageHistoryApi = (nodeId) => request.get(`/api/v1/business/node-chat-message/history/${nodeId}`)

/**
 * 流式发送节点对话消息（SSE推送）
  POST /api/v1/business/node-chat-message/send-stream
 * @param {Object} data - 请求参数
 * @param {number} data.nodeId - 节点ID
 * @param {string} data.userQuestion - 用户问题
 * @param {Function} onMessage - 接收消息的回调函数 (chunk) => void
 * @param {Function} onStart - 开始生成的回调函数 () => void
 * @param {Function} onEnd - 结束生成的回调函数 () => void
 * @param {Function} onError - 错误处理回调函数 (error) => void
 * @returns {Object} 包含 close 方法的对象，用于关闭连接
 */
export const postNodeChatMessageSendStreamApi = (data, { onMessage, onStart, onEnd, onError }) => {
  const baseURL = import.meta.env.VITE_BASE_URL.replace(/\/$/, '');
  const token = localStorage.getItem('token');
  const clientId = import.meta.env.VITE_APP_CLIENT_ID;

  // 构建完整的 SSE URL
  const url = `${baseURL}/api/v1/business/node-chat-message/send-stream?nodeId=${data.nodeId}&userQuestion=${encodeURIComponent(data.userQuestion)}`;

  // 使用 fetch 实现 SSE，因为需要自定义 headers
  const controller = new AbortController();
  let currentEvent = null;
  let currentData = '';

  fetch(url, {
    method: 'POST',
    headers: {
      'Authorization': token || '',
      'clientid': clientId || '',
      'Accept': 'text/event-stream',
    },
    signal: controller.signal,
  })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = '';

      const processLine = (line) => {
        if (line.trim() === '') {
          // 空行表示一个完整的事件结束
          if (currentEvent && currentData !== null) {
            const dataToSend = currentData.trim();
            if (dataToSend) {
              try {
                // 尝试解析 JSON
                const parsed = JSON.parse(dataToSend);
                if (currentEvent === 'start' && onStart) {
                  onStart(parsed);
                } else if (currentEvent === 'message' && onMessage) {
                  onMessage(parsed);
                } else if (currentEvent === 'end' && onEnd) {
                  onEnd(parsed);
                } else if (currentEvent === 'error' && onError) {
                  onError(parsed);
                }
              } catch (e) {
                // 如果不是 JSON，直接传递字符串
                if (currentEvent === 'start' && onStart) {
                  onStart(dataToSend);
                } else if (currentEvent === 'message' && onMessage) {
                  onMessage(dataToSend);
                } else if (currentEvent === 'end' && onEnd) {
                  onEnd(dataToSend);
                } else if (currentEvent === 'error' && onError) {
                  onError(dataToSend);
                }
              }
            } else if (currentEvent === 'start' && onStart) {
              // 即使没有数据，也触发 start 事件
              onStart();
            } else if (currentEvent === 'end' && onEnd) {
              // 即使没有数据，也触发 end 事件
              onEnd();
            }
          }
          currentEvent = null;
          currentData = '';
          return;
        }

        if (line.startsWith('event:')) {
          currentEvent = line.substring(6).trim();
        } else if (line.startsWith('data:')) {
          const data = line.substring(5); // 保留原始数据，包括可能的换行
          if (currentData === '') {
            currentData = data;
          } else {
            currentData += '\n' + data;
          }
        }
      };

      const readStream = () => {
        reader.read().then(({ done, value }) => {
          if (done) {
            // 处理剩余的 buffer
            if (buffer) {
              buffer.split('\n').forEach(processLine);
            }
            if (onEnd) onEnd();
            return;
          }

          buffer += decoder.decode(value, { stream: true });
          const lines = buffer.split('\n');
          buffer = lines.pop() || ''; // 保留最后一个不完整的行

          lines.forEach(processLine);

          readStream();
        }).catch(error => {
          if (error.name !== 'AbortError' && onError) {
            onError(error);
          }
        });
      };

      readStream();
    })
    .catch(error => {
      if (onError) onError(error);
    });

  // 返回一个可以关闭连接的对象
  return {
    close: () => controller.abort(),
    abort: () => controller.abort(),
  };
}

/**
 * 流式发送节点对话消息（使用前端传递的候选人信息，SSE推送）
  POST /api/v1/business/node-chat-message/send-stream-with-candidate
 * @param {Object} data - 请求参数
 * @param {number} data.nodeId - 节点ID
 * @param {string} data.userQuestion - 用户问题
 * @param {string} data.candidateResume - 候选人简历（字符串，可选）
 * @param {string} data.interviewDetailsJson - 面试详情（序列化后的JSON字符串，可选）
 * @param {Function} onMessage - 接收消息的回调函数 (chunk) => void
 * @param {Function} onStart - 开始生成的回调函数 () => void
 * @param {Function} onEnd - 结束生成的回调函数 () => void
 * @param {Function} onError - 错误处理回调函数 (error) => void
 * @returns {Object} 包含 close 方法的对象，用于关闭连接
 */
export const postNodeChatMessageSendStreamWithCandidateApi = (data, { onMessage, onStart, onEnd, onError }) => {
  const baseURL = import.meta.env.VITE_BASE_URL.replace(/\/$/, '');
  const token = localStorage.getItem('token');
  const clientId = import.meta.env.VITE_APP_CLIENT_ID;

  // 构建请求体
  const requestBody = {
    nodeId: data.nodeId,
    userQuestion: data.userQuestion,
  };

  if (data.candidateResume) {
    requestBody.candidateResume = data.candidateResume;
  }

  if (data.interviewDetailsJson) {
    requestBody.interviewDetailsJson = data.interviewDetailsJson;
  }

  // 构建完整的 SSE URL
  const url = `${baseURL}/api/v1/business/node-chat-message/send-stream-with-candidate`;

  // 使用 fetch 实现 SSE，因为需要自定义 headers
  const controller = new AbortController();
  let currentEvent = null;
  let currentData = '';

  fetch(url, {
    method: 'POST',
    headers: {
      'Authorization': token || '',
      'clientid': clientId || '',
      'Content-Type': 'application/json',
      'Accept': 'text/event-stream',
    },
    body: JSON.stringify(requestBody),
    signal: controller.signal,
  })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = '';

      const processLine = (line) => {
        if (line.trim() === '') {
          // 空行表示一个完整的事件结束
          if (currentEvent && currentData !== null) {
            const dataToSend = currentData.trim();
            if (dataToSend) {
              try {
                // 尝试解析 JSON
                const parsed = JSON.parse(dataToSend);
                if (currentEvent === 'start' && onStart) {
                  onStart(parsed);
                } else if (currentEvent === 'message' && onMessage) {
                  onMessage(parsed);
                } else if (currentEvent === 'end' && onEnd) {
                  onEnd(parsed);
                } else if (currentEvent === 'error' && onError) {
                  onError(parsed);
                }
              } catch (e) {
                // 如果不是 JSON，直接传递字符串
                if (currentEvent === 'start' && onStart) {
                  onStart(dataToSend);
                } else if (currentEvent === 'message' && onMessage) {
                  onMessage(dataToSend);
                } else if (currentEvent === 'end' && onEnd) {
                  onEnd(dataToSend);
                } else if (currentEvent === 'error' && onError) {
                  onError(dataToSend);
                }
              }
            } else if (currentEvent === 'start' && onStart) {
              // 即使没有数据，也触发 start 事件
              onStart();
            } else if (currentEvent === 'end' && onEnd) {
              // 即使没有数据，也触发 end 事件
              onEnd();
            }
          }
          currentEvent = null;
          currentData = '';
          return;
        }

        if (line.startsWith('event:')) {
          currentEvent = line.substring(6).trim();
        } else if (line.startsWith('data:')) {
          const data = line.substring(5); // 保留原始数据，包括可能的换行
          if (currentData === '') {
            currentData = data;
          } else {
            currentData += '\n' + data;
          }
        }
      };

      const readStream = () => {
        reader.read().then(({ done, value }) => {
          if (done) {
            // 处理剩余的 buffer
            if (buffer) {
              buffer.split('\n').forEach(processLine);
            }
            if (onEnd) onEnd();
            return;
          }

          buffer += decoder.decode(value, { stream: true });
          const lines = buffer.split('\n');
          buffer = lines.pop() || ''; // 保留最后一个不完整的行

          lines.forEach(processLine);

          readStream();
        }).catch(error => {
          if (error.name !== 'AbortError' && onError) {
            onError(error);
          }
        });
      };

      readStream();
    })
    .catch(error => {
      if (onError) onError(error);
    });

  // 返回一个可以关闭连接的对象
  return {
    close: () => controller.abort(),
    abort: () => controller.abort(),
  };
}



